import PropTypes from 'prop-types';
import { Fragment } from 'react';
import ViewToolbarShareButton from './toolbar/ViewToolbarShareButton';
import ViewToolbarDownloadButton from './toolbar/ViewToolbarDownloadButton';
import ViewSender from './ViewSender';
import PresentationRecord from '../../records/PresentationRecord';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ViewActions({
  brandingColor,
  presentation,
  fetchDownloadLink,
  meetingLink
}) {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(ViewToolbarShareButton, {
      brandingColor: brandingColor,
      shortLink: presentation.shortLink
    }), /*#__PURE__*/_jsx(ViewToolbarDownloadButton, {
      brandingColor: brandingColor,
      presentation: presentation,
      fetchDownloadLink: fetchDownloadLink
    }), /*#__PURE__*/_jsx(ViewSender, {
      user: presentation.user,
      meetingLink: meetingLink,
      brandingColor: brandingColor
    })]
  });
}
ViewActions.propTypes = {
  brandingColor: PropTypes.string.isRequired,
  presentation: PropTypes.instanceOf(PresentationRecord),
  meetingLink: PropTypes.string,
  fetchDownloadLink: PropTypes.func.isRequired
};
export default ViewActions;